import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory from 'react-bootstrap-table2-editor';
import ToolkitProvider, { Search, CSVExport } from 'react-bootstrap-table2-toolkit';
import paginationFactory, { PaginationProvider, PaginationListStandalone, PaginationTotalStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';

const { ExportCSVButton } = CSVExport;

const listaDatos = ({ id, datos, columnas, striped, hover, condensed, selectRow, onDoubleClick, clases, borrar, cellEdit, rowStyle, tagExtra, buscar, paginacion, showExport }) => {

    const customTotal = (from, to, size) => (
        <span className="react-bootstrap-table-pagination-total">
            Mostrando {from} a {to} de {size} Resultados
        </span>
    );

    const calculasizePerPageList = (cantidad) => {

        let lista = [];
        if (!paginacion) {
            lista = [{
                text: 'Todo', value: cantidad
            }];
            return lista;
        }

        if (!cantidad || cantidad === 0) {
            lista = [{
                text: '0', value: 5
            }, {
                text: 'Todo', value: cantidad
            }];
            return lista;
        }

        if (cantidad <= 15) {
            lista = [{
                text: '5', value: 5
            }, {
                text: '10', value: 10
            }, {
                text: 'Todo', value: cantidad
            }];
            return lista;
        }

        if (cantidad <= 20) {
            lista = [{
                text: '5', value: 5
            }, {
                text: '10', value: 10
            }, {
                text: '15', value: 15
            }, {
                text: 'Todo', value: cantidad
            }];
            return lista;
        }

        if (cantidad <= 50) {
            lista = [{
                text: '5', value: 5
            }, {
                text: '10', value: 10
            }, {
                text: '15', value: 15
            }, {
                text: '25', value: 25
            }, {
                text: '35', value: 35
            }, {
                text: 'Todo', value: cantidad
            }];
            return lista;
        }

        if (cantidad > 50) {
            lista = [{
                text: '5', value: 5
            }, {
                text: '10', value: 10
            }, {
                text: '15', value: 15
            }, {
                text: '25', value: 25
            }, {
                text: '35', value: 35
            }, {
                text: '65', value: 65
            }, {
                text: '85', value: 85
            }, {
                text: '100', value: 100
            }, {
                text: 'Todo', value: cantidad
            }];
            return lista;
        }
    }

    const { SearchBar } = Search;

    const _sizePerPageList = calculasizePerPageList(datos.length);
    const borra = borrar !== undefined ? borrar : false;
    const ExtraTag = tagExtra != undefined ? tagExtra : (() => { return (<></>) })

    let optPaginacion = {
        custom: true,
        paginationSize: 4,
        pageStartIndex: 0,
        alwaysShowAllBtns: true, // Always show next and previous button
        withFirstAndLast: true, // Hide the going to First and Last page button
        hideSizePerPage: false, // Hide the sizePerPage dropdown always
        hidePageListOnlyOnePage: true, // Hide the pagination list when only one page 
        firstPageText: 'Primero',
        prePageText: 'Anterior',
        nextPageText: 'Siguiente',
        lastPageText: 'Ultimo',
        nextPageTitle: 'Primera Página',
        prePageTitle: 'Pre page',
        firstPageTitle: 'Siguiente Página',
        lastPageTitle: 'Ultima Página',
        showTotal: true,
        paginationTotalRenderer: customTotal,
        //sizePerPageList: _sizePerPageList, // A numeric array is also available. the purpose of above example is custom the text
        sizePerPageList: _sizePerPageList,
        variation: 'dropup',
        dataSize: datos.length
    };

    if (borra) {
        optPaginacion.page = 0;
    }

    const rowEvents = {
        onDoubleClick: (e, row, rowIndex) => {
            onDoubleClick();
        }
    };

    let buscarGr = buscar == undefined ? true : buscar;
    let paginacionGr = paginacion == undefined ? true : paginacion;
    const NoDatos = 'No hay datos que mostrar';

    return (
        <ToolkitProvider keyField={id} data={datos} columns={columnas} search>
            {
                props => (
                    <div>
                        {
                            buscarGr || showExport ?
                                <div className='row'>
                                    <div className={"col-xs-12"} >
                                        {
                                            buscarGr ?
                                                <div class="col-xs-2">
                                                    <SearchBar {...props.searchProps} placeholder="Buscar" />
                                                </div>
                                                : null
                                        }
                                        {
                                            showExport ?
                                                <div style={{ float: "left" }}>
                                                    <ExportCSVButton {...props.csvProps} className="btn btn-sm pull-right flipInX animated"  >
                                                        <i className="fa fa-file-excel-o" ></i>
                                                    </ExportCSVButton>
                                                </div>
                                                : null
                                        }
                                    </div>
                                </div>
                                : null
                        }
                        <PaginationProvider pagination={paginationFactory(optPaginacion)}>
                            {
                                ({
                                    paginationProps,
                                    paginationTableProps
                                }) => (
                                    <div>
                                        <div className='table-responsive'>
                                            <BootstrapTable
                                                {...props.baseProps}
                                                {...paginationTableProps}
                                                striped={striped}
                                                hover={hover}
                                                condensed={condensed}
                                                selectRow={selectRow}
                                                rowEvents={rowEvents}
                                                className={clases}
                                                noDataIndication={NoDatos}
                                                cellEdit={cellEditFactory(cellEdit)}
                                                rowStyle={rowStyle}
                                            />
                                            {ExtraTag}
                                        </div>
                                        {
                                            paginacionGr ?
                                                <>
                                                    <SizePerPageDropdownStandalone
                                                        {...paginationProps}
                                                    />
                                                    <PaginationTotalStandalone
                                                        {...paginationProps}
                                                    />
                                                    <PaginationListStandalone
                                                        {...paginationProps}
                                                    />
                                                </>
                                                : null
                                        }
                                    </div>
                                )
                            }
                        </PaginationProvider>
                    </div>
                )
            }
        </ToolkitProvider>
    );
};

export default listaDatos;